module.exports = __webpack_public_path__ + "static/media/events-polygon-icon.56093aa0.png";